/** A short, readable date and time for an ISO timestamp, such as `Oct 2, 08:30`. A value that is
 *  not a date comes back unchanged. */
export function formatShortDate(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false });
}

/** A long date and time for a status line, such as `Oct 1, 2026 at 21:14`. A value that is not a
 *  date comes back unchanged. */
export function formatStatusDate(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const day = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  const time = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false });
  return `${day} at ${time}`;
}

/** A short date without a time, such as `Oct 2`. A value that is not a date comes back unchanged. */
export function formatDay(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
